// import axios from "axios";

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// export const FETCH_TASK_SUBMISSIONS_REQUEST = "FETCH_TASK_SUBMISSIONS_REQUEST";
// export const FETCH_TASK_SUBMISSIONS_SUCCESS = "FETCH_TASK_SUBMISSIONS_SUCCESS";
// export const FETCH_TASK_SUBMISSIONS_FAILURE = "FETCH_TASK_SUBMISSIONS_FAILURE";

// export const fetchAllTaskSubmissions = () => {
//   return async (dispatch) => {
//     dispatch({ type: FETCH_TASK_SUBMISSIONS_REQUEST });
//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.get(
//         `${BASE_URL}/v1/api/admin/getAllTaskSubmitByAdmin`,
//         {
//           headers: { authorization: token },
//         }
//       );
//       dispatch({
//         type: FETCH_TASK_SUBMISSIONS_SUCCESS,
//         payload: response.data.data,
//       });
//     } catch (error) {
//       const message = error.response?.data?.message || error.message;
//       dispatch({
//         type: FETCH_TASK_SUBMISSIONS_FAILURE,
//         payload: message,
//       });
//     }
//   };
// };


import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_TASK_SUBMISSIONS_REQUEST = "FETCH_TASK_SUBMISSIONS_REQUEST";
export const FETCH_TASK_SUBMISSIONS_SUCCESS = "FETCH_TASK_SUBMISSIONS_SUCCESS";
export const FETCH_TASK_SUBMISSIONS_FAILURE = "FETCH_TASK_SUBMISSIONS_FAILURE";

export const fetchAllTaskSubmissions = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TASK_SUBMISSIONS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/getAllTaskSubmitByAdmin`,
        {
          headers: { Authorization: token },
        }
      );

      if (response?.data?.meta?.status) {
        dispatch({
          type: FETCH_TASK_SUBMISSIONS_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: FETCH_TASK_SUBMISSIONS_FAILURE,
          payload: response.data?.meta?.message || "Failed to fetch task submissions.",
        });
      }
    } catch (error) {
      const message = error.response?.data?.meta?.message || error.message;
      dispatch({
        type: FETCH_TASK_SUBMISSIONS_FAILURE,
        payload: message,
      });
    }
  };
};
